import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React, { cloneElement } from "react";
import {
  Button,
  Datagrid,
  Filter,
  FunctionField,
  List,
  ReferenceField,
  ResourceContextProvider,
  RowClickFunction,
  sanitizeListRestProps,
  SearchInput,
  ShowProps,
  TextField,
  TopToolbar,
  useListContext,
} from "react-admin";
import IconPlus from "@material-ui/icons/Add";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";
import StatusField from "components/StatusField";
import { SchoolIdSelected } from "utils/tools";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, history, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      <Button
        onClick={() =>
          history.push(
            `/students/create?source=${JSON.stringify({
              parentId: Number(props.filterValues?.ParentId),
            })}&parentId=${Number(props.filterValues?.ParentId)}`
          )
        }
        label="Create Student"
      >
        <IconPlus />
      </Button>
    </TopToolbar>
  );
};

const Student = (props: ShowProps) => {
  const rowClick: RowClickFunction = (id, basePath, record) =>
    `/students/${id}/show?parentId=${props.id}`;

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Students</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="students">
          <List
            {...props}
            exporter={false}
            filters={<ThisFilter />}
            filterDefaultValues={{
              ParentId: Number(props.id),
              IsMain: true,
              SchoolId: Number(SchoolIdSelected()),
            }}
            bulkActionButtons={false}
            title=" "
            actions={<ListActions history={props.history} />}
          >
            <Datagrid rowClick={rowClick}>
              <FunctionField
                label="Student Info"
                render={() => (
                  <SanitizedGrid container spacing={2}>
                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Id :
                      </Typography>
                      <TextField source="id" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Name :
                      </Typography>
                      <FunctionField
                        render={(record: any) =>
                          `${record.firstName} ${record.lastName}`
                        }
                        emptyText="-"
                      />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Gender :
                      </Typography>
                      <TextField source="gender" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Birthday :
                      </Typography>
                      <CustomDateField source="dateOfBirth" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        School :
                      </Typography>
                      <ReferenceField
                        source="schoolId"
                        reference="schools"
                        emptyText="-"
                        link={false}
                      >
                        <TextField source="name" emptyText="-" />
                      </ReferenceField>
                    </Grid>
                  </SanitizedGrid>
                )}
              />
              <StatusField source="status" />
              <CustomDateField
                source="createdAt"
                label="Created On"
                emptyText="-"
                isDateTime
              />
            </Datagrid>
          </List>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default Student;
